<template>
  <div>
    <h2 data-cy="privateHomePlaceHolder">{{ t('privateHome.title') }}</h2>
    <p>
      This route implements the route guards [AuthGuard, AccountExistsGuard, EmailVerifiedGuard] by
      using the 'email_verified' access type in the route configuration.
    </p>
    <ul>
      <li>
        <a
          href="https://git.tsi.com/projects/SAAS/repos/auth-v3/browse/src/auth/utils.ts"
          target="_blank"
          >Auth Access Types</a
        >
      </li>
      <li>
        <a href="https://components.tsi.com/v3/dev/router" target="_blank"
          >Vue 3 Components Router</a
        >
      </li>
    </ul>
    <FusionReactivateAccountDialog />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'

export default defineComponent({
  name: 'PrivateHome',
  setup() {
    const { t } = useI18n({ useScope: 'global', messages })
    return { t }
  }
})
</script>
